import { IApplicationState } from '../../types/redux';
import { IPromo } from '../../types/developer/promos';
import { getFskPromoUrl } from '../../utils/getFskPromoUrl';

export function getPromos(state: IApplicationState): IPromo[] {
  if (state.fsk?.promoSlider) {
    return state.fsk.promoSlider.map((promo, index) => {
      const hasCallbackPopup = Boolean(promo.hasCallbackPopup);

      return {
        image: promo.image,
        newbuildingId: index,
        url: getFskPromoUrl({ isEmpty: hasCallbackPopup, hitUrl: promo.hitUrl || '', erid: promo.erid }),
        erId: promo.erid,
        hasCallbackPopup,
      };
    });
  }

  return state.developer.promos.map(promo => ({
    ...promo,
    hasCallbackPopup: promo.newbuildingId === 0,
  }));
}
